import { c as _c } from "react/compiler-runtime";
import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import { LocalizedDateRange } from '@/components/Atoms/LocalizedDateRange/LocalizedDateRange';
import { LocalizedTime } from '@/components/Atoms/LocalizedTime/LocalizedTime';
import { TimeDuration } from '@/components/Atoms/TimeDuration/TimeDuration';
import Calendar from '@/components/Icons/Calendar';
import Duration from '@/components/Icons/Duration';
import Location from '@/components/Icons/Location';
import useTranslation from '@/hooks/useTranslation';
import type { IEvent } from '@/interfaces';
import { getDurationSecondsFromDates } from '@/utils/dateUtils';
import type { FCl } from 'react-fc';
import styled from 'styled-components';
export const EventMetadata: FCl<IProps> = t0 => {
  const $ = _c(72);
  const {
    className,
    event
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("Event.Location.online");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let eventLocation = `${t1}`;
  if (event.location) {
    eventLocation = event.location;
  }
  let showDuration = false;
  let t2;
  if ($[2] !== event.endDate || $[3] !== event.startDate) {
    t2 = getDurationSecondsFromDates(new Date(event.startDate), new Date(event.endDate));
    $[2] = event.endDate;
    $[3] = event.startDate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const durationSeconds = t2;
  if (durationSeconds < 86400) {
    showDuration = true;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Calendar />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("Event.heading.date");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Icon use={t3} size={IconSize.SMALL} title={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("Event.heading.date");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Hidden>{t6}</Hidden>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <dt>{t5}{t7}</dt>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== event.endDate || $[18] !== event.isDateProvisional || $[19] !== event.startDate || $[20] !== t) {
    t9 = event.isDateProvisional ? t("Event.tbc") : <LocalizedDateRange startDate={event.startDate} endDate={event.endDate} />;
    $[17] = event.endDate;
    $[18] = event.isDateProvisional;
    $[19] = event.startDate;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <dd>{t9}</dd>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div>{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Duration />;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("Event.heading.time");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = <Icon use={t12} size={IconSize.SMALL} title={t13} />;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("Event.heading.time");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15) {
    t16 = <Hidden>{t15}</Hidden>;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t16) {
    t17 = <dt>{t14}{t16}</dt>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== durationSeconds || $[40] !== event.isDateProvisional || $[41] !== event.startDate || $[42] !== showDuration || $[43] !== t) {
    t18 = event.isDateProvisional ? t("Event.tbc") : <><LocalizedTime time={event.startDate} />{" "}{showDuration && <TimeDuration asAddendum={true} durationInSeconds={durationSeconds} title={t("Event.heading.duration")} />}</>;
    $[39] = durationSeconds;
    $[40] = event.isDateProvisional;
    $[41] = event.startDate;
    $[42] = showDuration;
    $[43] = t;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t18) {
    t19 = <dd>{t18}</dd>;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t17 || $[48] !== t19) {
    t20 = <div>{t17}{t19}</div>;
    $[47] = t17;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Location />;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t) {
    t22 = t("Labels.location");
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t22) {
    t23 = <Icon use={t21} size={IconSize.SMALL} title={t22} />;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t) {
    t24 = t("Labels.location");
    $[55] = t;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t24) {
    t25 = <Hidden>{t24}</Hidden>;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t23 || $[60] !== t25) {
    t26 = <dt>{t23}{t25}</dt>;
    $[59] = t23;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== eventLocation) {
    t27 = <dd>{eventLocation}</dd>;
    $[62] = eventLocation;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t26 || $[65] !== t27) {
    t28 = <div>{t26}{t27}</div>;
    $[64] = t26;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== className || $[68] !== t11 || $[69] !== t20 || $[70] !== t28) {
    t29 = <StyledMetadataList className={className}>{t11}{t20}{t28}</StyledMetadataList>;
    $[67] = className;
    $[68] = t11;
    $[69] = t20;
    $[70] = t28;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  return t29;
};
interface IProps {
  event: IEvent;
}
export const StyledMetadataList = styled.dl`
    display: block;
    > * {
        display: flex;
        align-items: center;
        gap: var(--size-grid-unit);
        dt {
            color: var(--color-body-accent);
            line-height: 0;
        }
        &:not(:last-child) {
            margin-bottom: var(--size-grid-unit);
        }
    }
`;